import { validator } from '@app/constant/FormConstant'
import { START_WITH_SPACE } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const validateValue = {
  images: {
    min: 1,
  },
  time_between_redeem: {
    min: 1,
  },
  codes_per_day: {
    min: 1,
  },
  line_of_credit: {
    min: 1,
    max: 100000000000,
  },
}

const CampaignCreateValidate = Yup.object().shape({
  name: Yup.string()
    .trim()
    .max(validator.NAME_MAX_LENGTH)
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>)
    .matches(START_WITH_SPACE, {
      message: <Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>,
    }),

  start_at: Yup.date()
    .min(new Date(), <Translation>{(t) => t('VALIDATE.VALIDATE_START_TIME')}</Translation>)
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_START_TIME')}</Translation>),

  end_at: Yup.date()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_END_TIME')}</Translation>)
    .when(
      'start_at',
      (start_at, schema) =>
        start_at && schema.min(start_at, <Translation>{(t) => t('VALIDATE.VALIDATE_END_TIME')}</Translation>)
    ),

  visible_from: Yup.date()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_START_DISPLAY')}</Translation>)

    .when(
      'start_at',
      (start_at, schema) =>
        start_at &&
        schema
          .min(start_at, <Translation>{(t) => t('VALIDATE.VALIDATE_START_DISPLAY')}</Translation>)
          .when(
            'end_at',
            (end_at, schema) =>
              end_at &&
              schema.max(end_at, <Translation>{(t) => t('VALIDATE.VALIDATE_START_DISPLAY_END_AT')}</Translation>)
          )
    ),

  visible_to: Yup.date()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_END_DISPLAY')}</Translation>)
    .when(
      'visible_from',
      (visible_from, schema) =>
        visible_from &&
        schema
          .min(visible_from, <Translation>{(t) => t('VALIDATE.VALIDATE_END_DISPLAY_START_DISPLAY')}</Translation>)
          .when(
            'end_at',
            (end_at, schema) =>
              end_at &&
              schema.max(end_at, <Translation>{(t) => t('VALIDATE.VALIDATE_END_DISPLAY_END_AT')}</Translation>)
          )
    ),

  codes_per_day: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_LIMIT_CODE_USER_PER_DAY')}</Translation>)
    .integer(<Translation>{(t) => t('VALIDATE.INTEGER_CODE_USER_PER_DAY')}</Translation>)
    .min(
      validateValue.codes_per_day.min,
      <Translation>
        {(t) => t('VALIDATE.VALID_LIMIT_CODE_USER_PER_DAY', { number: validateValue.codes_per_day.min })}
      </Translation>
    ),

  time_between_redeem: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_TIME_BETWEEN_REDEEM_CODE')}</Translation>)
    .integer(<Translation>{(t) => t('VALIDATE.INTEGER_TIME_BETWEEN_REDEEM_CODE')}</Translation>)
    .min(
      validateValue.time_between_redeem.min,
      <Translation>
        {(t) => t('VALIDATE.VALID_TIME_BETWEEN_REDEEM_CODE', { number: validateValue.time_between_redeem.min })}
      </Translation>
    ),

  line_of_credit: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_LINE_OF_CREDIT')}</Translation>)
    .integer(<Translation>{(t) => t('VALIDATE.INTEGER_LINE_OF_CREDIT')}</Translation>)
    .min(
      validateValue.line_of_credit.min,
      <Translation>
        {(t) => t('VALIDATE.VALID_LINE_OF_CREDIT', { number: validateValue.line_of_credit.min })}
      </Translation>
    )
    .max(
      validateValue.line_of_credit.max,
      <Translation>
        {(t) => t('VALIDATE.VALID_LINE_OF_CREDIT_MAX', { number: validateValue.line_of_credit.max })}
      </Translation>
    ),

  partner_id: Yup.string().required(<Translation>{(t) => t('VALIDATE.REQUIRED_PARTNER')}</Translation>),

  images: Yup.array()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_SLIDER')}</Translation>)
    .min(
      validateValue.images.min,
      <Translation>{(t) => t('VALIDATE.VALIDATE_SLIDER', { number: validateValue.images.min })}</Translation>
    ),
})

export default CampaignCreateValidate
